import { VideoSource } from "@/constants/media";
import { useGetVideoURL } from "../hooks";
import VideoIFrame from "../VideoIFrame";

type Numeric = 0 | 1;

// https://developers.google.com/youtube/player_parameters#Parameters
export type YouTubeOptions = {
  autoplay: Numeric;
  loop?: Numeric;
  playlist?: string;
};

export interface YouTubeVideoProps {
  videoId: string;
  options?: YouTubeOptions;
}

const defaultOptions: YouTubeOptions = {
  autoplay: 1,
};

export default function YouTubeVideo(props: YouTubeVideoProps) {
  const { videoId, options: customOptions } = props;
  const options = { ...defaultOptions, ...customOptions };
  const videoURL = useGetVideoURL(VideoSource.YouTube, videoId);

  if (options.loop) {
    options.playlist = options.playlist ?? videoId;
  }

  return <VideoIFrame src={videoURL} options={options} />;
}
